class VideoDetector {
 constructor() {
   this.videos = document.querySelectorAll("video");
   this.attachEventListeners();
 }

 attachEventListeners() {
   this.videos.forEach(video => {
     if (video) {
      const btn = video.parentElement.querySelector(`button.button`);
       if (video.addEventListener) {
         video.addEventListener("click", this.togglePlayPause, false);
         btn.addEventListener("click", this.togglePlayBtn, false);
       } else if (video.attachEvent) {
         video.attachEvent("onclick", this.togglePlayPause);
         btn.attachEvent("onclick", this.togglePlayBtn);
       } else {
         video.onclick = this.togglePlayPause;
         btn.onclick = this.togglePlayBtn;
       }
     }
   });
 }

 togglePlayBtn() {
  const video = this.parentElement.querySelector(`video`)
  video.click();
 }

 togglePlayPause(event) {
   event.preventDefault();
   const video = event.currentTarget;
   const videoContainer = video.parentElement;
   console.log(`togglePlayPause`);
   if (video.paused) {
     videoContainer.classList.add('active');
     video.play();
   } else {
     videoContainer.classList.remove('active');
     video.pause();
   }
 }
}

const videoDetector = new VideoDetector();